import { Modal } from "react-bootstrap";
import { Button } from "../button";
import { GenericForm } from "../generic-form";

import { RequestDigitalSignatureModalProps } from "./RequestDigitalSignatureModal.types";
import { useRequestDigitalSignature } from "./useRequestDigitalSignature";

export const RequestDigitalSignatureModal = ({
  isVisible,
  onDismiss,
  onSubmit,
  creating,
  requestDigitalSignatureForm,
}: RequestDigitalSignatureModalProps) => {
  const { t } = useRequestDigitalSignature();

  return (
    <Modal show={isVisible} animation onHide={onDismiss}>
      <Modal.Header>
        <h5 className="modal-title" id="Dismiss Modal">
          {t("DOCUMENTS.CREATE_DIGITAL_SIGNATURE_REQUEST")}
        </h5>
        <div onClick={onDismiss}>
          <span className="font-20 cursor-pointer">&times;</span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <GenericForm
          form={requestDigitalSignatureForm}
          onSubmit={onSubmit}
          submitControl={(submit) => (
            <div className="flex-row">
              <Button
                isLoading={creating}
                loader={{ size: "s" }}
                className="btn btn-primary mt-3 w-100"
                type="submit"
              >
                {t("REQUEST_BUTTON")}
              </Button>
            </div>
          )}
        />
      </Modal.Body>
    </Modal>
  );
};
